function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 44",
  id: "Layer_44"
}, /*#__PURE__*/React.createElement("path", {
  d: "M60,4.15H4a1.5,1.5,0,0,0-1.5,1.5V39.08A1.5,1.5,0,0,0,4,40.58H60a1.5,1.5,0,0,0,1.5-1.5V5.65A1.5,1.5,0,0,0,60,4.15ZM58.5,37.58H5.5V7.15h53Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M52,44H4a1.5,1.5,0,0,0,0,3H52A1.5,1.5,0,0,0,52,44Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38.49,50.42H4a1.5,1.5,0,0,0,0,3H38.49A1.5,1.5,0,0,0,38.49,50.42Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28,56.85H4a1.5,1.5,0,0,0,0,3H28A1.5,1.5,0,0,0,28,56.85Z"
}));

function SvgCardFullImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardFullImage);
export default __webpack_public_path__ + "static/media/card_full_image.68eaa815.svg";
export { ForwardRef as ReactComponent };